import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';

const FeatureFlagsList = ({ flags, selectedFlag, onFlagSelect }) => {
  return (
    <div className="space-y-4">
      {flags.length === 0 ? (
        <p className="text-gray-500 dark:text-slate-400 text-center py-8 italic">No feature flags found</p>
      ) : (
        flags.map((flag) => {
          const flagId = flag.id || flag.Id || '';
          const selectedFlagId = selectedFlag?.id || selectedFlag?.Id;
          const isEnabled = flag.enabled !== undefined ? flag.enabled : flag.Enabled;
          const description = flag.description || flag.Description;
          const isSelected = selectedFlagId === flagId;

          return (
            <div
              key={flagId}
              onClick={() => onFlagSelect(flag)}
              className={`
                bg-white dark:bg-slate-900 p-4 rounded-lg border shadow-sm cursor-pointer group transition-all
                ${isSelected ? 'border-blue-500 ring-2 ring-blue-200 shadow-md' : 'border-gray-200 dark:border-slate-700 hover:shadow-md hover:border-gray-300 dark:hover:border-slate-600'}
              `}
            >
              <div className="flex justify-between items-start mb-2">
                <span className="font-medium text-gray-800 dark:text-gray-200 text-sm">{flagId}</span>
                {isEnabled ? (
                  <CheckCircle2 className="w-5 h-5 text-blue-500 shrink-0" />
                ) : (
                  <XCircle className="w-5 h-5 text-gray-400 dark:text-slate-500 shrink-0" />
                )}
              </div>
              {description && (
                <p className="text-xs text-gray-500 dark:text-slate-400 line-clamp-2">{description}</p>
              )}
            </div>
          );
        })
      )}
    </div>
  );
};

export default FeatureFlagsList;
